import type { ReactNode } from 'react';
import { ErrorBoundary, type ErrorBoundaryFallbackProps } from './ErrorBoundary';

function AppCrashFallback({ error, reset }: ErrorBoundaryFallbackProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-primary px-6">
      <div className="w-full max-w-xl rounded-2xl border border-border bg-bg-secondary p-6 shadow-2xl">
        <p className="text-xs uppercase tracking-[0.2em] text-text-muted">Application error</p>
        <h1 className="mt-3 text-2xl font-bold text-text-primary">Lynx Crypto failed to render</h1>
        <p className="mt-2 text-sm text-text-secondary">
          A recoverable UI error blocked the app shell. Retry first; reload if the error persists.
        </p>
        {import.meta.env.DEV && (
          <pre className="mt-4 max-h-56 overflow-auto rounded-lg border border-border bg-bg-primary p-3 text-xs text-text-muted">
            {error.message}
          </pre>
        )}
        <div className="mt-5 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={reset}
            className="rounded bg-accent px-4 py-2 text-sm font-medium text-white hover:opacity-90"
          >
            Retry
          </button>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded border border-border px-4 py-2 text-sm font-medium text-text-primary hover:bg-bg-hover"
          >
            Reload page
          </button>
        </div>
      </div>
    </div>
  );
}

export function AppErrorBoundary({ children }: { children: ReactNode }) {
  return <ErrorBoundary fallback={({ error, reset }) => <AppCrashFallback error={error} reset={reset} />}>{children}</ErrorBoundary>;
}
